import AutoUnitValueField from "./AutoUnitValueField.mjs";

const AutoPercentField = class extends AutoUnitValueField {
	constructor(props) {
		super(props);
		this.state.units = [{label:"%",value:"%",multi: .01 }];
		this.state.multi = .01;
		this.state.min = 0;
		this.state.max = 100;
		this.state.slider = true;
	}
}

export default AutoPercentField;